import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface I18nProviderProps {
  children: React.ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
  const { i18n } = useTranslation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkReady = () => {
      if (i18n.isInitialized) {
        setIsReady(true);
      } else {
        // Wait for i18n to initialize
        i18n.on('initialized', () => {
          setIsReady(true);
        });
      }
    };

    checkReady();

    return () => {
      i18n.off('initialized');
    };
  }, [i18n]);

  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return <>{children}</>;
}
